'use client';

import { useState, useEffect } from 'react';
import Title from '@fe-news/components/atoms/AsideAiNews/Title';
import Content from '@fe-news/components/atoms/AsideAiNews/Content';
import Link from 'next/link';
import Error from '@fe-news/components/atoms/AsideAiNews/Error';
import Loading from '@fe-news/components/atoms/AsideAiNews/Loading';
import { AiCategoryType } from '@fe-news/constants/ai/type';
import { useQuery } from '@tanstack/react-query';
import { GETAiNewsV2 } from '@fe-news/api/ai';

type YuShanProps = {
  type: AiCategoryType;
  url: string;
  isAiGc?: boolean;
};

const YuShan = ({ type, url, isAiGc = false }: YuShanProps) => {
  const [isTitleLoaded, setIsTitleLoaded] = useState(false);

  const { data, isError, isFetching } = useQuery({
    queryKey: ['ai-news', type],
    queryFn: () => GETAiNewsV2({ type, page: 1 })
  });

  const aiData = data?.items?.data?.[0];

  useEffect(() => {
    setIsTitleLoaded(false);
  }, [type]);

  if (isFetching) {
    return <Loading />;
  }

  return (
    <>
      {isError || (!aiData && <Error />)}
      {!isError && aiData && (
        <>
          <Link href={url} prefetch={false}>
            <Title setIsTitleLoaded={setIsTitleLoaded} title={aiData.title} />
          </Link>
          {isTitleLoaded && <Content content={aiData.content} isAiGc={isAiGc} />}
        </>
      )}
    </>
  );
};

export default YuShan;
